import { render } from "./nuevaNoticia.vue?vue&type=template&id=219461f6&scoped=true"
import script from "./nuevaNoticia.vue?vue&type=script&lang=js"
export * from "./nuevaNoticia.vue?vue&type=script&lang=js"

import "./nuevaNoticia.vue?vue&type=style&index=0&id=219461f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219461f6"]])

export default __exports__